import React, {useMemo} from 'react';
import Article from './Article.jsx';
import Blocker from './Blocker.jsx';
import Teaser from './Teaser.jsx';
import {Constants} from '../view-constants';
import {useBreakpointCurrent} from 'bonprix-design-system';

function Alpi({
    alpiGiven,
    shopContent,
    positionIndex,
    pointOfSaleId,
    latestAlpiIndexLoaded,
    calculateLatestLoadedAlpi,
    maxOrdering,
    navigateToProduct,
    contentLoadedCounter,
    filterTrackingValue,
    rankingTrackingValue,
    teaserContent,
}) {
    const breakpoint = useBreakpointCurrent();

    const renderedArticle = useMemo(() => {
        if (alpiGiven.gridItem.displayType !== Constants.GRIDITEM_ARTICLE) {
            return null;
        }
        return (
            <Article
                key={`article_${positionIndex}_${contentLoadedCounter}`}
                givenAlpi={alpiGiven}
                shopContent={shopContent}
                positionIndex={positionIndex}
                pointOfSaleId={pointOfSaleId}
                calculateLatestLoadedAlpi={calculateLatestLoadedAlpi}
                latestAlpiIndexLoaded={latestAlpiIndexLoaded}
                navigateToProduct={navigateToProduct}
                filterTrackingValue={filterTrackingValue}
                rankingTrackingValue={rankingTrackingValue}
            />
        );
    }, [latestAlpiIndexLoaded, alpiGiven.gridItem.displayType]);

    if (!alpiGiven.gridItem || alpiGiven.gridItem.displayType === 'FILLER_ARTICLE') {
        return <></>;
    }

    const clazzes = 'alpi ' + (alpiGiven.classes ? alpiGiven.classes : '');
    const ordering = alpiGiven.orderings[breakpoint.toUpperCase()];

    const shouldRenderAlpi = Number.isInteger(ordering) && ordering <= maxOrdering;

    if (alpiGiven.gridItem.displayType === Constants.GRIDITEM_TEASER) {
        return shouldRenderAlpi ? (
            <Teaser teaserModel={alpiGiven.gridItem.teaserModel} clazzes={clazzes} pageModel={teaserContent} />
        ) : (
            <></>
        );
    }

    if (alpiGiven.gridItem.displayType === Constants.GRIDITEM_BLOCKER) {
        return shouldRenderAlpi ? <Blocker clazzes={clazzes} /> : <></>;
    }

    return <>{renderedArticle}</>;
}

export default Alpi;
